import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../../../components/common/utils/handleError.component';
import { PolizaEntity } from '../../entities/polizas_cliente_entity';
import { MovimientosVamService } from './movimientosVam.service';
import { RedesVamEntity } from '../../../vam/vam_entity';
import { PlanVam, MovimientosVamEntity, ResultadoMovmientosPorPlan ,ConsultaSiniestralidad, BusquedaFacturacion, FacturacionPrestacion, Facturacion} from '../../entities/vam_entities';
import { ComboBox } from '../../../../components/common/utils/combobox';
import { ClienteXCiudad ,ConsultaCliente} from '../../../login/cliente_login';
import { SessionStorageService } from 'ngx-webstorage';
import { FileUploader } from 'ng2-file-upload';
import { ArchivosMoivimientos } from '../../entities/movimientos_entity';
import { ConstantService } from '../../../../components/common/utils/constant.service';
import { Archivo } from '../../../../components/common/utils/entities/util_entity';
const swal = require("sweetalert2");
declare var jQuery: any;
@Component({
    selector: 'movimientosVam',
    templateUrl: 'movimientosVam.template.html'
})

export class MovimientosVamComponent implements OnChanges {
    comboAseguradora: ComboBox[];
    busquedaFacturacion: BusquedaFacturacion;
    showLoader: string;
    codigoGrupo: number;
    nombreGrupo: string;
    codigoCliente: number;
    codigoCiudad: number;
    codigoUnidad: number;
    opcionCliente: number;
    comboClientes: ComboBox[];
    comboRamos: ComboBox[];
    comboPrestaciones: ComboBox[];
    comboAnios: ComboBox[];
    comboMeses: ComboBox[];
    comboTipoNegocio: ComboBox[];
    tipoFacturacion: number;
    facturacionConsultada: boolean;
    prestacionFacturada: boolean;
    primaPlan: number;
    primaGuardada: boolean;
    public facturaPrestacion: FacturacionPrestacion;

    public resumenRamo;
    public movimientosRamo;
    public inclusionRamo:Facturacion[];
    exclusionRamo:Facturacion[];
    sinMovRamo:Facturacion[];
    cambioCatRamo:Facturacion[];
    cambioEmpRamo:Facturacion[];
    public resumenPrestacion;
    public detallePrestacion;
    public tipoPrestacion;
    public grupoSeleccionado;
    fechaDesde: Date;
    fechaHasta: Date;
    public pendientesRamo;
    ejecutivocliente:number;
    usuarioempresaretrive: ClienteXCiudad;
    CodigoCarta: number;
    es: any = {
        firstDayOfWeek: 1,
        dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
        dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", 'julio', "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
        monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
    };
    yearRange: string;
    maxDate: Date;
    minDate: Date;
    public uploaderInc: FileUploader;
    private url = "movimientos";
    adjuntos:Archivo[];

    constructor(private route: ActivatedRoute,
         private router: Router,
          private handleError: HandleError,
          public sesionStorageService: SessionStorageService,
           public movimientosService: MovimientosVamService) {
               
            this.inclusionRamo = [];
           }
    ngOnChanges(changes: SimpleChanges): void {
        throw new Error('Method not implemented.');
    }

    ngOnInit(): void {
        this.busquedaFacturacion = new BusquedaFacturacion();
        this.busquedaFacturacion.CodigoCiudad = Number(sessionStorage.getItem("ciudad"));
        this.busquedaFacturacion.CodigoUnidad = Number(sessionStorage.getItem("unidad"));
        //console.log(sessionStorage.getItem("ejecutivoSeleccionado"));
        this.ejecutivocliente=Number(sessionStorage.getItem("ejecutivoSeleccionado"));
        this.busquedaFacturacion.CodigoCliente = 0;
        this.busquedaFacturacion.CodigoGrupo = 0;
        this.busquedaFacturacion.CodigoTipoNegocio = 0;
        this.busquedaFacturacion.CodigoRamo = "0";
        this.busquedaFacturacion.CodigoPrestacion = 0;
        this.busquedaFacturacion.Mes = 0;
        this.busquedaFacturacion.Anio = 0;
        this.busquedaFacturacion.Aseguradora= 0;
        this.facturacionConsultada = false;
        this.prestacionFacturada = false;
        this.facturaPrestacion = new FacturacionPrestacion();
        this.comboRamos = [];
        this.comboPrestaciones = [];
        this.opcionCliente = 1;
        this.codigoGrupo = 0;
        this.tipoFacturacion = 1;
        this.resumenRamo = [];
        this.movimientosRamo = [];
        
        this.exclusionRamo = [];
        this.sinMovRamo = [];
        this.cambioCatRamo = [];
        this.cambioEmpRamo = [];
        this.pendientesRamo=[];
        this.resumenPrestacion = [];
        this.detallePrestacion = [];
        this.tipoPrestacion = 0;
        this.grupoSeleccionado = 0;
        this.primaPlan = 0;
        this.primaGuardada = false;
        this.adjuntos=[];
        let now = new Date(Date.now());
        let past = new Date(Date.now());
        past.setFullYear(past.getFullYear() - 10);
        this.yearRange = (now.getFullYear() - 10) + ":" + now.getFullYear();
        this.maxDate = now;
        this.minDate = past;
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
        try {
            this.usuarioempresaretrive = JSON.parse(this.sesionStorageService.retrieve("usuarioempresa"));
        } catch (e) {
            this.usuarioempresaretrive = this.sesionStorageService.retrieve("usuarioempresa");
        }
       this.codigoCliente= this.usuarioempresaretrive.CodigoCliente;
       this.codigoCiudad= this.usuarioempresaretrive.Ciudad;
       this.codigoUnidad= this.usuarioempresaretrive.CodigoUnidad;
       this.codigoGrupo=this.usuarioempresaretrive.CodigoGrupo;
       let consultaCliente = new ConsultaCliente();
            consultaCliente.Cliente = this.codigoCliente;
            consultaCliente.Grupo = this.usuarioempresaretrive.CodigoGrupo;
            consultaCliente.Ciudad =  this.codigoCiudad;
            consultaCliente.Unidad = Number(sessionStorage.getItem("unidad"));
       this.movimientosService.getClientes(consultaCliente).subscribe(infoPantalla => {
        this.comboClientes = infoPantalla;
        this.showLoader = "";

        //this.busquedaFacturacion.CodigoCliente = this.codigoCliente;
        this.busquedaFacturacion.CodigoCiudad = this.codigoCiudad;
        this.busquedaFacturacion.CodigoGrupo=this.usuarioempresaretrive.CodigoGrupo;
        
      //this.consultarFacturacion();
        // this.uploaderInc.onAfterAddingFile = (file) => {
        //     this.uploadAllFiles(this.CodigoCarta);

        //     file.withCredentials = false;
        // };
        
    }, error => {
        this.showLoader = "";
        swal({
            title: 'Error al cargar los clientes',
            text: error,
            type: 'error',
            confirmButtonColor: '#A14950',
            confirmButtonText: 'Aceptar'
        })
    });
    this.uploaderInc = new FileUploader({
        url: this.url + '/ConsultarAdjuntos',
        allowedMimeType: ['image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/x-zip-compressed'
        ],
        maxFileSize: 5 * 1024 * 1024, /*limitado a 5 MB*/
        removeAfterUpload: true
    });
    this.uploaderInc.options.headers = [];
    this.inclusionRamo = [];
    }
    set dateFechaDesde(e) {
        this.fechaDesde = new Date(e);
    }

    get dateFechaDesde() {
        if (this.fechaDesde != undefined) {
            try {
                let a = this.fechaDesde.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                let a = this.fechaDesde.toString().substring(0, 10);
                let b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }
    set dateFechaHasta(e) {
        this.fechaHasta = new Date(e);
    }

    get dateFechaHasta() {
        if (this.fechaHasta != undefined) {
            try {
                let a = this.fechaHasta.toISOString().substring(0, 10);
                let b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                let a = this.fechaHasta.toString().substring(0, 10);
                let b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }

    onCambiarCliente() {
        this.busquedaFacturacion.CodigoCliente = 0;
        this.busquedaFacturacion.CodigoGrupo = 0;
        this.busquedaFacturacion.CodigoRamo = "0";
        this.busquedaFacturacion.CodigoPrestacion = 0;
        this.busquedaFacturacion.CodigoTipoNegocio = 0;
        this.busquedaFacturacion.Mes = 0;
        this.busquedaFacturacion.Anio = 0;
        this.grupoSeleccionado = 0;
        this.primaPlan = 0;
        this.primaGuardada = false;
        this.busquedaFacturacion.Aseguradora= 0;
        if (this.opcionCliente == 2) {
            this.busquedaFacturacion.CodigoGrupo = this.codigoGrupo;
            this.grupoSeleccionado = this.busquedaFacturacion.CodigoGrupo;
            this.consultarTipoDeNegocio();
        }
    }

    consultarTipoDeNegocio() {
        if (this.busquedaFacturacion.CodigoCliente != 0 || this.busquedaFacturacion.CodigoGrupo != 0) {
            this.showLoader = "sk-loading";
            this.movimientosService.getTipoNegocio(this.busquedaFacturacion).subscribe(data => {
                this.comboTipoNegocio = data;
                this.showLoader = "";
            }, error => {
                this.showLoader = "";
                swal({
                    title: 'Error al cargar los clientes',
                    text: error,
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            });
        }

    }
    consultarRamosPrestaciones() {
        this.comboRamos = [];
        this.comboPrestaciones = [];
        this.busquedaFacturacion.CodigoRamo = "0";
        if (this.busquedaFacturacion.CodigoTipoNegocio != 0) {
            this.showLoader = "sk-loading";
            this.movimientosService.getCombos(this.busquedaFacturacion).subscribe(data => {
                this.comboPrestaciones = data.Prestaciones;
                this.comboRamos = data.Ramos;
                this.showLoader = "";
            }, error => {
                this.showLoader = "";
                swal({
                    title: 'Error al cargar los clientes',
                    text: error,
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            });
        }
    }
    onChangeTipoFacturacion() {
        this.busquedaFacturacion.CodigoRamo = "0";
        this.busquedaFacturacion.CodigoPrestacion = 0;
        this.busquedaFacturacion.Mes = 0;
        this.busquedaFacturacion.Anio = 0;
        this.busquedaFacturacion.Aseguradora= 0;
        this.primaPlan = 0;
        this.primaGuardada = false;
    }
    onChangeRamo(){
        this.busquedaFacturacion.Aseguradora= 0;
        if(this.busquedaFacturacion.CodigoRamo != "0" ){
            if( this.busquedaFacturacion.CodigoTipoNegocio == 1 || this.busquedaFacturacion.CodigoTipoNegocio == 2){
                this.movimientosService.getAseguradora(this.busquedaFacturacion).subscribe(data => {
                    this.comboAseguradora = data;
                    this.showLoader = "";
                }, error => {
                    this.showLoader = "";
                    swal({
                        title: 'Error al cargar aseguradoras',
                        text: error,
                        type: 'error',
                        confirmButtonColor: '#A14950',
                        confirmButtonText: 'Aceptar'
                    })
                });
            }else{
                
            }
            
        }
        
    }


    limpiarConsulta() {
        this.busquedaFacturacion.CodigoCliente = 0;
        this.busquedaFacturacion.CodigoGrupo = 0;
        this.busquedaFacturacion.CodigoRamo = "0";
        this.busquedaFacturacion.CodigoPrestacion = 0;
        this.busquedaFacturacion.CodigoTipoNegocio = 0;
        this.busquedaFacturacion.Mes = 0;
        this.busquedaFacturacion.Anio = 0;
        this.facturacionConsultada = false;
        this.prestacionFacturada = false;
        this.facturaPrestacion = new FacturacionPrestacion();
        this.primaPlan = 0;
        this.primaGuardada = false;
    }
    consultarFacturacion() {
        this.facturacionConsultada = true;
        this.prestacionFacturada = false;
        this.showLoader = "sk-loading";
        this.tipoPrestacion = this.busquedaFacturacion.CodigoPrestacion;
        this.busquedaFacturacion.FechaDesde = this.fechaDesde;
        this.busquedaFacturacion.FechaHasta = this.fechaHasta;
        
        this.movimientosService.getConsultarDetalleMovimientos(this.busquedaFacturacion).subscribe(data => {

            if (this.tipoFacturacion == 1) {
                this.showLoader = "";
                this.resumenRamo = data.Ramo.Resumen;
                this.movimientosRamo = data.Ramo.Movimientos;
                this.inclusionRamo = data.Ramo.TitularesIncluidos;
                this.exclusionRamo = data.Ramo.TitularesExcluidos;
                this.sinMovRamo = data.Ramo.TitularesSinMovimientos;
                this.cambioCatRamo = data.Ramo.CambioCategoria;
                this.cambioEmpRamo = data.Ramo.CambioEmpresa;
                this.pendientesRamo=data.Ramo.Pendientes;
                this.primaPlan = data.Ramo.PrimaFacturada;
                if(this.primaPlan > 0){
                    this.primaGuardada = true;
                }else{
                    this.primaGuardada = false;
                }
            } else {
               this.resumenPrestacion = data.Prestacion.Resumen;
               this.detallePrestacion = data.Prestacion.Detalle;
                this.movimientosService.getValidarFacturacion(this.busquedaFacturacion).subscribe(b => {

                    this.prestacionFacturada = b.Validado;
                    console.log(this.prestacionFacturada);
                    this.showLoader = "";

                }, error => {
                    this.showLoader = "";
                    swal({
                        title: 'Error al consultar otros ingresos',
                        text: error,
                        type: 'error',
                        confirmButtonColor: '#A14950',
                        confirmButtonText: 'Aceptar'
                    })
                });
            }

        }, error => {
            this.showLoader = "";
            swal({
                title: 'Error al consultar la facturación',
                text: error,
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
        });
    }
    uploadAllFiles(carcod: number): void {
        //this.showLoader = "sk-loading";
      let  archivosAdjuntosSubida: ArchivosMoivimientos[];
      let  archivosAdjuntosSubidaVacio: ArchivosMoivimientos[];
      //console.log(this.archivosAdjuntos)
        const xhr = new XMLHttpRequest();
        const form = new FormData();

        for (const fileItem of this.uploaderInc.getNotUploadedItems()) {
            form.append(fileItem.file.name, fileItem._file, fileItem.file.name);
        }

        xhr.onreadystatechange = (function () {
            if (xhr.readyState === 4) {
               // this.showLoadermodal = "";
                var archivos = jQuery.parseJSON(xhr.response);

                archivosAdjuntosSubida=archivos;
                 if(archivosAdjuntosSubida!.length>0){
                    //console.log("1")
                    this.archivosAdjuntos = archivosAdjuntosSubida;
                }
                else
                {
                    //console.log("2")
                    this.archivosAdjuntos=archivosAdjuntosSubidaVacio;
                }
                
                
            }
        }).bind(this);
        xhr.open("post", this.url + '/ConsultarAdjuntos/'+carcod, true);
        xhr.setRequestHeader("enctype", "multipart/form-data");
        // IE workaround for Cache issues
        xhr.setRequestHeader("Cache-Control", "no-cache");
        xhr.setRequestHeader("Cache-Control", "no-store");
        xhr.setRequestHeader("Pragma", "no-cache");

        //let objetoPreautorizacion = JSON.stringify(aut);

        //xhr.setRequestHeader("Preautorizacion", objetoPreautorizacion);
        xhr.send(form);
        console.log(this.url + '/GenerarCarta')

    }

    VerAdjuntosMovimientos(carCod:number){

        this.movimientosService.ConsultarAdjuntosMovimientos(carCod).subscribe(data => {
            this.adjuntos = data;
            this.showLoader = "";
          if(this.adjuntos.length!=0){
            jQuery('#myModal').modal('show');
          }
          else{
            this.showLoader = "";
            swal({
                title: 'Sin adjuntos',
                text: 'El movimiento no posee adjuntos',
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
          }

        }, error => {
            this.showLoader = "";
            swal({
                title: 'Error al cargar los adjuntos',
                text: error,
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
        });
       
        //file.withCredentials = false;

    }
    descargar(archivo: Archivo) {
        console.log("1");
        this.movimientosService.getArchivo(archivo).subscribe(
            result => {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.className = "hidden"
                let fileBlob = result.blob();
                let blob = null;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    blob = new Blob([fileBlob], {
                        type: 'application/pdf'
                    });
                }
                if (archivo.Extension.toUpperCase() == "JPG") {
                    blob = new Blob([fileBlob], {
                        type: 'image/jpg'
                    });
                }
                if (archivo.Extension.toUpperCase() == "PNG") {
                    blob = new Blob([fileBlob], {
                        type: 'image/png'
                    });
                }
                if (archivo.Extension.toUpperCase() == "XLSX" || archivo.Extension.toUpperCase() == "XLS") {
                    blob = new Blob([fileBlob], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                }
                if (archivo.Extension.toUpperCase() == "DOCX") {
                    blob = new Blob([fileBlob], {
                        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                    });
                }
                if (archivo.Extension.toUpperCase() == "MSG") {
                    blob = new Blob([fileBlob], {
                        type: 'application/ms-outlook'
                    });
                }
                if (archivo.Extension.toUpperCase() == "RAR") {
                    blob = new Blob([fileBlob], {
                        type: 'application/x-rar-compressed'
                    });
                }
                if (archivo.Extension.toUpperCase() == "ZIP") {
                    blob = new Blob([fileBlob], {
                        type: '	application/zip'
                    });
                }
                if (archivo.Extension.toUpperCase() == "TXT") {
                    blob = new Blob([fileBlob], {
                        type: '	application/text'
                    });
                }

                let url = window.URL.createObjectURL(blob);
                a.href = url;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "XLSX"||archivo.Extension.toUpperCase() == "XLS") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "DOCX") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "JPG") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "PNG") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "MSG") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "RAR") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "ZIP") {
                    a.download = archivo.Nombre;
                }

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    if (archivo.Extension.toUpperCase() == "XLSX"||archivo.Extension.toUpperCase() == "XLS") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".xlsx");
                    }
                    if (archivo.Extension.toUpperCase() == "PDF") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".pdf");
                    }
                    if (archivo.Extension.toUpperCase() == "DOCX") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".docx");
                    }
                    if (archivo.Extension.toUpperCase() == "JPG") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".jpg");
                    }
                    if (archivo.Extension.toUpperCase() == "PNG") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".png");
                    }
                    if (archivo.Extension.toUpperCase() == "MSG") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".msg");
                    }
                    if (archivo.Extension.toUpperCase() == "RAR") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".rar");
                    }
                    if (archivo.Extension.toUpperCase() == "ZIP") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".zip");
                    }
                    console.log("2");
                }
                else {
                    a.click();
                    console.log("3");
                    window.URL.revokeObjectURL(url);
                }
                //this.showLoader = "";
            },
            error => {
                console.log(error);
            }
        );
    }
    cerraradjuntos(){

        jQuery('#myModal').modal('hide');  
    }
    exportarDetalleMovimientos() {
        // this.showLoader = "sk-loading";
        // this.busquedaFacturacion.FechaDesde= this.fechaDesde;
        // this.busquedaFacturacion.FechaHasta= this.fechaHasta;
        
        // this.movimientosService.getExportarDetalleMovimientos(this.busquedaFacturacion).subscribe(result => {
        //     var a = document.createElement("a");
        //     document.body.appendChild(a);
        //     a.className = "hidden";
        //     let fileBlob = result.blob();
        //     let blob = new Blob([fileBlob], {
        //         type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // must match the Accept type
        //     });
        //     let url = window.URL.createObjectURL(blob);
        //     a.href = url;
        //     let codigoAutogenerado = new Date();
        //     a.download = "DetalleMovimientos.xlsx";
    
        //     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //         window.navigator.msSaveOrOpenBlob(blob, "DetalleMovimientos.xlsx");
        //     }
        //     else {
        //         a.click();
        //         window.URL.revokeObjectURL(url);
        //     }
        //     this.showLoader = "";
        //     swal({
        //         title: 'Archivo generado',
        //         text: 'Se ha descargado exitósamente el archivo con los movimientos del titulares.',
        //         type: 'success',
        //         confirmButtonColor: '#A14950',
        //         confirmButtonText: 'Aceptar'
        //     })
    
        // }, error => {
        //     this.showLoader = "";
        //     console.log(error);
        //     swal({
        //         title: 'Error al descargar archivo de movimientos del titulares',
        //         text: 'No se pudo generar el archivo, por favor vuelva a intentar. En caso de volver a presentarse el mismo mensaje reportelo al Departamento de Tecnología.',
        //         type: 'error',
        //         confirmButtonColor: '#A14950',
        //         confirmButtonText: 'Aceptar'
        //     })
        // });
    }

    
  
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/movimientos/movimientosVam.component.ts